export type LstMetrics = {
	loaded: boolean;
	priceInSol: number;
	lstPriceApy30d: number;
	emissionsApy?: number;
	driftEmissions?: number;
};
